var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['order-status', `status-${_vm.item}`]},[_vm._v(_vm._s(_vm.item ? _vm.getI18N("orders.statuses.shippingStatuses", _vm.item) : ""))])
}
var staticRenderFns = []

export { render, staticRenderFns }